<template>
  <div style="height: 100%">
    <v-row class="rowView">
      <v-col
        class="colView h5"
        :cols="12"
        style="color: var(--color-text)"
      >
        Vessel route
      </v-col>
    </v-row>

    <v-row
      class="rowView"
      style="height: calc(100% - 25px)"
    >
      <Map
        :vessels="vesselPosition"
        :voyage="vesselVoyage"
        :start="vesselStart"
        :multiColor="true"
        :showLevels="false"
      />
    </v-row>
  </div>
</template>

<script>
import Map from "../../../components/Map";

export default {
  name: "FoulingRoutePanel",
  components: { Map },
  props: {
    vesselPosition: { type: Array, required: true },
    vesselVoyage: { type: Array, required: true },
    vesselStart: { type: Array, required: true },
  },
};
</script>
